import { useAuth } from '@/store/auth';
import Aegis from 'aegis-web-sdk';

export enum AegisEventMap {
  'REQUEST_ERROR' = 'REQUEST_ERROR',
  'REQUEST_INFO' = 'REQUEST_INFO',
  'REQUEST_SUCCESS' = 'REQUEST_SUCCESS',
  'REQUEST_COST' = 'REQUEST_COST', // 请求耗时

  'WUP_INFO' = 'WUP_INFO', // wup请求信息
  'WUP_SUCCESS' = 'WUP_SUCCESS', // wup请求成功
  'WUP_ERROR' = 'WUP_ERROR', // wup请求错误
  'WUP_TIMEOUT' = 'WUP_TIMEOUT', // wup请求超时

  'RENDER_ERROR' = 'RENDER_ERROR', // 渲染错误
  'CALL_NATIVE_METHOD' = 'CALL_NATIVE_METHOD', // 调用终端方法前
  'CALL_NATIVE_METHOD_ERROR' = 'CALL_NATIVE_METHOD_ERROR', // 调用终端方法发生错误
  'CALL_NATIVE_METHOD_DONE' = 'CALL_NATIVE_METHOD_DONE', // 调用终端接口完成

  'LOGIN_ERROR' = 'LOGIN_ERROR', // 登录失败相关

  'PAGE_LOADED' = 'PAGE_LOADED', // 页面加载完成
}

const aegis = new Aegis({
  id: '5GQVWue8KrPyOOLVj5', // 项目上报id
  reportApiSpeed: true, // 接口测速
  reportAssetSpeed: true, // 静态资源测速
});
async function getUin() {
  await useAuth.fetch();
  return useAuth.storeInfo()?.deviceInfo?.tguid;
}
export async function init() {
  const uin = await getUin();
  console.log('🚀 ~ file: aegis.ts:40 ~ init ~ uin:', uin);
  aegis.setConfig({
    uin,
  });
}

export const aegisReportRetError = (msg: any) => {
  aegis.report({
    msg,
    level: Aegis.logType.RET_ERROR,
  });
};

export { aegis };
